import { computed, ref } from 'vue'
import { defineStore } from 'pinia'

import { AnalyticsTree } from './utils/types'
import { DuckDBSchemaType } from '@/services/duckdb/utils/types'

import { getTreeFilterableNodes, prepareTree } from './utils/helpers'

import useAnalyticsStore from '../index'

import { DuckDBService } from '@/services/duckdb'

export const TABLE_NAME = 'analytics_tree'

const TABLE_SCHEMA: Record<string, DuckDBSchemaType> = {
  amount: 'DOUBLE',
  balance: 'DOUBLE',
  path: 'VARCHAR[]',
}

export default defineStore('analytics-tree', () => {
  // INIT
  const duckdbInstance = DuckDBService.instance()

  const analyticsStore = useAnalyticsStore()

  const list = ref<AnalyticsTree[]>([])

  const loading = ref(false)
  const deprecated = ref<boolean>()
  const trigger = ref(0)

  // GETTERS
  const isInit = computed(() => deprecated.value !== undefined)

  const getList = computed(() => {
    if (analyticsStore.getError) return
    return list.value
  })

  const getPreparedData = computed(() => prepareTree(getList.value))

  const getFilterableNodes = computed(() =>
    getTreeFilterableNodes(getList.value, getPreparedData.value),
  )

  // SETTERS
  const setList = async (data: { tree_view: AnalyticsTree[] }) => {
    if (deprecated.value === false) return
    if (!data.tree_view) return
    list.value = data.tree_view
    deprecated.value = false
    await duckdbInstance.createTable(TABLE_NAME, TABLE_SCHEMA)
    await duckdbInstance.pushData(TABLE_NAME, data.tree_view, TABLE_SCHEMA)
    trigger.value++
  }

  // ACTIONS
  const clear = () => {
    list.value = []
    loading.value = false
    deprecated.value = undefined
    trigger.value = 0
  }

  return {
    isLoading: loading,
    isDeprecated: deprecated,

    isInit,
    trigger,

    getList,
    getFilterableNodes,
    getPreparedData,

    setList,

    clear,
  }
})
